import styled from 'styled-components';

import { StyledLabel, TextInput } from '../TextFieldAtom/TextFieldAtom.styled';

/* ----------------------------- StyledDropdownAtom ----------------------------- */

const DropdownHeader = styled.div<{ isPlaceholder: boolean }>(
    ({ theme, isPlaceholder }) => `
    background-color: ${theme.sections.light};
    border-radius: 0.3rem;
    border: 0.06rem solid ${theme.sections.medium};
    color: ${isPlaceholder ? theme.sections.medium : theme.sections.dark};
    cursor: pointer;
    height: 44px;
    padding: 0.65rem 0.5rem;
    width: 100%;

    font-size: 1rem;
    @media screen and (min-width: 48rem) {
        font-size: 1.125rem;
    }

    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
`,
);

export const Icon = styled.i(
    ({ theme }) => `
    color: ${theme.sections.medium};

    &.fa {
        font-size: 0.675rem;
    }
`,
);

export const List = styled.div(
    ({ theme }) => `
    position: absolute;
    max-height: 10rem;
    overflow-y: scroll;
    background-color: ${theme.sections.light};
    z-index: 10;
    width: 100%;
    border: 1px solid ${theme.sections.mediumLight};
    border-top: none;
    border-radius: 0.3rem;
    box-shadow: 0 2px 3px 0 rgba(0,0,0,0.3);

    &:empty {
        padding-bottom:1.5rem;
    }

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-track {
        background: none;
    }

    &::-webkit-scrollbar-thumb {
        background:  ${theme.sections.mediumLight};
        border-radius: 0.01rem;
    }

    &::-webkit-scrollbar-thumb:hover {
        background:  ${theme.sections.medium};
    }

    &::-webkit-scrollbar {
        display: none;
    }

    &:hover {
        &::-webkit-scrollbar {
            display: block;
        }
    }
`,
);

export const Button = styled.div<{ active: boolean; selected: boolean }>(
    ({ active, theme, selected }) => `
    padding: 0.875rem 0.65rem;
    border-bottom: 1px solid ${theme.sections.mediumLight};
    cursor: pointer;
    color: ${theme.sections.dark};
    background-color: ${
        selected || active ? theme.sections.mediumLight : theme.sections.light
    };

    &:hover {
        background-color: ${theme.sections.dark}09;
    }

    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
`,
);

export const InputWrapper = styled.div`
    position: relative;
`;

export const StyledDropdownLabel = styled(StyledLabel)<{
    open: boolean;
}>(
    ({ theme, open }) => `
        padding-bottom: 1.5rem;
        display: block;
        position: relative;
        outline: none;

        ${DropdownHeader} {
            border: 0.06rem solid
                ${open ? theme.sections.page.feature : theme.sections.medium};
        }

        &:active,
        &:focus {
            ${DropdownHeader} {
                border: 0.06rem solid ${theme.sections.page.feature};
            }
        }

        ${TextInput}{
            padding-right: 2.5rem;
        }

        ${Icon}{
            position: absolute;
            right: 0.675rem;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
        }
    `,
);
